module.exports = "<div loadtrack></div>\n<div loadscript></div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/track/track.html
// module id = 92
// module chunks = 0